import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { FieldTree } from '@angular/forms/signals';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-checkbox-group',
  imports: [SvgIconComponent],
  templateUrl: './checkbox-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // A caller's static `id` attribute also lands on this host element, and this keeps
  // it off, since `optionInputId`/`labelId` already derive their own ids from it.
  host: { '[attr.id]': 'null' },
})
export class CheckboxGroupComponent {
  readonly field = input.required<FieldTree<string[]>>();
  readonly id = input('');
  readonly label = input('');
  readonly hideLabel = input(false);
  readonly options = input<string[]>([]);
  readonly containerClass = input('');

  protected readonly state = computed(() => this.field()());

  protected readonly labelText = computed(() =>
    this.state().required() ? `${this.label()} *` : this.label()
  );

  get labelId(): string {
    return `${this.id()}-label`;
  }

  get optionList(): string[] {
    return this.options();
  }

  isSelected(option: string): boolean {
    const current = this.state().value() ?? [];
    return current.includes(option);
  }

  onToggle(option: string, event: Event): void {
    const input = event.target as HTMLInputElement | null;
    const checked = input?.checked ?? false;
    const current = new Set(this.state().value() ?? []);
    if (checked) current.add(option);
    else current.delete(option);

    this.state().value.set(Array.from(current));
    this.state().markAsDirty();
    this.state().markAsTouched();
  }

  trackByOption(_: number, option: string): string {
    return option;
  }

  optionInputId(index: number): string {
    return `${this.id()}-option-${index}`;
  }
}
